import { Component, OnInit } from '@angular/core';
import * as $ from 'jquery';
import 'datatables.net'

@Component({
  selector: 'app-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CustomComponent implements OnInit {
    tableHeaders: string[] =
    [
        "Name",
        "Purpose",
        "Assessment type",
        "Niche",
        "Actions"
    ];

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
      this.initDatatable()
  }

  private initDatatable(): void {
      let tableId: any = $('#table');
      let tableWidget = tableId.DataTable({
          select: true,
          pageLength: 25,
          dom: 'Bfrtip',
      });
      $('.dataTables_length, .dataTables_filter').hide();
      $('.next').css('float', 'right');
  }

}
